import { defineComponent, h } from 'vue';

export default defineComponent({
  name: 'ResponseList',
  props: ['questionSet', 'totalCount'],
  setup(props, { parent }) {
    return function render() {
      const responses = props.questionSet.map(
        item => h('p', {
          class: [
            'px-3',
            'my-2',
            'flex',
            'justify-between',
          ],
        }, [
          h(
            'span',
            { class: ['text-left', 'flex-1'] },
            item.response,
          ),
          props.totalCount ? h(
            'span',
            { class: ['text-right', 'text-60', 'w-12'] },
            item.count,
          ) : null,
          props.totalCount ? h(
            'span',
            { class: ['text-right', 'text-60', 'w-24'] },
            `(${parent.$n(item.count / props.totalCount, 'analyticsPercentage')
              .replace(' %', '%')})`,
          ) : null,
        ]),
      );

      return h('div', {
        class: {
          border: true,
          rounded: true,
          'border-50': true,
          'overflow-auto': true,
          'h-32': true,
          'bg-40': !props.questionSet.length,
        },
      }, responses);
    };
  }
});
